import React from 'react';
import PropTypes from 'prop-types';

const MarketingBannerCTA = ({ ctaText, handleBannerClick, theme = {}, url }) => {
  if (!ctaText || !url) return null;
  const handleCTAClick = e => {
    e.stopPropagation();
    handleBannerClick({ page_action_location: 'cta' });
  };

  const ctaProps = {
    className: theme.CTA,
    onClick: handleCTAClick,
  };

  return <button {...ctaProps}>{ctaText}</button>;
};

export default MarketingBannerCTA;

MarketingBannerCTA.propTypes = {
  ctaText: PropTypes.string.isRequired,
  handleBannerClick: PropTypes.func.isRequired,
  theme: PropTypes.shape({}).isRequired,
  url: PropTypes.string.isRequired,
};
